import type { ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './ChangeList.css'

export interface ChangeListItem {
  id: string
  title: ReactNode
  /** Condición en el subtítulo, p. ej. "Gratis hasta el 1 oct · pagas solo la diferencia" */
  condition?: ReactNode
  /** Cancelar la reserva: en rojo y al final */
  destructive?: boolean
  href?: string
  onClick?: () => void
}

export interface ChangeListProps {
  items: ChangeListItem[]
  className?: string
}

/** Lista de cambios (bundle B5): filas de 64 px con condición en subtítulo; la destructiva en error y al final. */
export function ChangeList({ items, className }: ChangeListProps) {
  const ordered = [...items.filter((i) => !i.destructive), ...items.filter((i) => i.destructive)]
  return (
    <ul className={cx('hp-changes', className)}>
      {ordered.map((it) => {
        const inner = (
          <>
            <span className="hp-changes__text">
              <span className="hp-changes__title">{it.title}</span>
              {it.condition && <span className="hp-changes__condition">{it.condition}</span>}
            </span>
            <Icon name="chevron-right" size={22} className="hp-changes__chevron" />
          </>
        )
        return (
          <li key={it.id} className={cx('hp-changes__item', it.destructive && 'hp-changes__item--destructive')}>
            {it.href ? (
              <a
                href={it.href}
                onClick={(e) => {
                  // Con onClick la app navega sin recargar (conserva la query); el href queda para abrir en otra pestaña.
                  if (!it.onClick) return
                  e.preventDefault()
                  it.onClick()
                }}
                className="hp-changes__row"
              >
                {inner}
              </a>
            ) : (
              <button type="button" onClick={it.onClick} className="hp-changes__row">
                {inner}
              </button>
            )}
          </li>
        )
      })}
    </ul>
  )
}
